import { Navigate, Outlet } from "react-router-dom";

// For routes that require authentication (e.g., /profile)
export function ProtectedRoute({ isAuthenticated, redirectTo = "/login" }) {
  return isAuthenticated ? <Outlet /> : <Navigate to={redirectTo} />;
}

// For routes that should NOT be accessible if logged in (e.g., /login, /register)
export function PublicRoute({ isAuthenticated, redirectTo = "/profile" }) {
  return !isAuthenticated ? <Outlet /> : <Navigate to={redirectTo} />;
}
